const checkOrderCancel = document.getElementById("check-ordered-cancel");
const checkReservedProduct = document.getElementById("check-reserved-product");
const checkedMap = new Map();
const falseText = "チェックをしてください";
let checkOutButton = document.getElementById("checkout");
let preservedSubmitHtml = checkOutButton.innerHTML;
let preservedSubmitDisabled = checkOutButton.disabled;
const changeSubmitText = (isValid = false) => {
  checkOutButton = document.getElementById("checkout");
  // console.log(isValid)
  if (isValid) {
    checkOutButton.disabled = preservedSubmitDisabled;
    checkOutButton.innerHTML = preservedSubmitHtml;
  } else {
    checkOutButton.disabled = true;
    checkOutButton.innerHTML = falseText;
  }
}
const isAllChecked = () => {
  let hasFalse = false;

  for (const [key, value] of checkedMap) {
    if (!value) hasFalse = true;
  }

  return !hasFalse;
}
const checkFunc = (type) => (event) => {
  checkedMap.set(type, event.currentTarget.checked)

  changeSubmitText(isAllChecked());
}

const addCheckboxChangeEvent = () => {
  let checkboxFields = Array.from(document.getElementsByClassName("cart-checkbox-field"));
  checkboxFields.forEach((checkboxField, index) => {
    checkedMap.set(index.toString(), checkboxField.checked);
    checkboxField.addEventListener("change", checkFunc(index.toString()));
  })
}

changeSubmitText();

addCheckboxChangeEvent();

